import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'

import { provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideHttp } from '@yoshu-lib/core/http/http.provider'
import { provideSocketInitializer } from '@yoshu-lib/core/socket/socket-initializer.factory'

import { environment } from '@forvia/env/environment'

import { routes } from './app.routes'
import { provideMarkdownCustomRenderer } from './core/config/marked-options.provider'
import { provideTranslate } from './core/config/translate.provider'
import { provideCore } from './core/core.providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    ...provideCore(),

    provideHttp(),
    provideAnimations(),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideMarkdown(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideSocketInitializer()
  ]
}
